import { render, staticRenderFns } from "./AbsensiLuarRadius.vue?vue&type=template&id=36e132b6&scoped=true"
import script from "./AbsensiLuarRadius.vue?vue&type=script&lang=js"
export * from "./AbsensiLuarRadius.vue?vue&type=script&lang=js"
import style0 from "./AbsensiLuarRadius.vue?vue&type=style&index=0&id=36e132b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e132b6",
  null
  
)

export default component.exports